import { required } from '../../../../utils/validators';

export const constraints = {
  code: [required()],
};

export interface FormData {
  code: string;
}
